import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const Badge = ({
  children, className, info, alarm, warning, positive, safe, ...others
}) => (
  <span
    className={cns(
      'badge',
      {
        'badge--info': info,
        'badge--alarm': alarm,
        'badge--warning': warning,
        'badge--positive': positive,
        'badge--safe': safe,
      },
      className,
    )}
    {...others}
  >
    {children}
  </span>
);

Badge.defaultProps = {
  alarm: false,
  children: null,
  className: '',
  info: false,
  positive: false,
  warning: false,
  safe: false,
};

Badge.propTypes = {
  /** Assegna lo stile testuale al badge */
  alarm: PropTypes.bool,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Assegna lo stile info al badge */
  info: PropTypes.bool,
  /** Assegna lo stile positive al badge */
  positive: PropTypes.bool,
  /** Assegna lo stile safe al badge */
  safe: PropTypes.bool,
  /** Assegna lo stile warning al badge */
  warning: PropTypes.bool,
};

export default Badge;
